const computed = {
    scores() {
      return this.$store.getters.scores;
    },
    readyForTopic() {
      return key => this.scores[key].readyForTopic;
    },
    sizeCategory() {
      return key => this.scores[key].sizeCategory;
    },
    hasNoOpinion() {
      return key => this.$store.state.answers[key].noOpinion;
    }
};

const methods = {
    toggleNoOpinion(key) {
      const current = this.$store.state.answers[key].noOpinion;
      this.$store.commit("updateNoOpinion", {
        topic: key,
        value: !current
      });
    },
    setNoOpinion(key) {
      this.$store.commit("updateNoOpinion", {
        topic: key,
        value: true
      });
    },
    unSetNoOpinion(key) {
      this.$store.commit("updateNoOpinion", {
        topic: key,
        value: false
      });
    }

};

export default { computed, methods };
